export default __webpack_public_path__ + "static/media/DNo.11-3.685f5c19.jpg";